import React, { useState, useReducer, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import ScrollView from "devextreme-react/scroll-view";
import { Link } from "react-router-dom";
import SiteMap from "../common/SiteMap";
import NEXUS_CONST from "../../common/constants";
import siteReducer from "../../reducers/siteDetails";
import * as actions from "../../actions/siteDetails";
import ACTION_TYPES from "../../actions/actionTypes";
import { postUserLog } from "../../actions/common";
import SelectBox from "../common/selectBox/SelectBox";
import * as utils from "../../common/utils";
import { Popup } from "devextreme-react/popup";
import ManageImage from "../common/manageImage/ManageImage";
import config from "../../common/config";

const initialState = {
  siteLocations: [],
  locationList: null,
  userHighestTier: null,
};
const SiteLocation = (props) => {
  const { category, history } = props;
  let navigate = useNavigate();
  const [state, dispatch] = useReducer(siteReducer, initialState);
  const { siteLocations, locationList, userHighestTier } = state;
  const [zoomMarker, setZoomMarker] = useState(null);
  const [zoomSiteInfo, setZoomSiteInfo] = useState(null);
  const [showSites, setShowSites] = useState(true);
  const [filterVal, setFilterVal] = useState("");
  const [activeTier, setActiveTier] = useState("4");
  const [isPopupVisible, setIsPopupVisibility] = useState(false);
  const [popupData, setPopupData] = useState({ siteData: [] });
  const [tierList, setTierList] = useState([]);

  useEffect(() => {
    if (userHighestTier) {
      generateAllowedTierList();
    }
  }, [userHighestTier]);

  const generateAllowedTierList = () => {
    let _tierList = utils.TIER_LIST.filter(
      (ele) => parseInt(ele.id) <= parseInt(userHighestTier)
    );
    setTierList(_tierList);
  };

  const onTierChange = (val) => {
    if (val.id == "8") {
      navigate("/sitehome/" + category + "/CORP_HON");
      return;
    } else {
      setActiveTier(val.id);
      setFilterVal("");
      actions.fetchSiteLocations(dispatch, category + "&tier=" + val.id);
    }
  };

  const togglePopup = () => {
    setPopupData({ siteData: [] });
    setIsPopupVisibility(!isPopupVisible);
  };

  const [scrollConfig] = useState({
    showScrollbar: "always",
    scrollByContent: true,
    scrollByThumb: true,
  });

  const filterSites = (e) => {
    setFilterVal(e.target.value);
    let filterKey = e.target.value.toLowerCase().trim();
    dispatch({
      type: ACTION_TYPES.SET_LOCATION_LIST,
      payload: filterKey
        ? _.filter(
            siteLocations,
            (data) =>
              data.siteName.toLowerCase().includes(filterKey) ||
              data.siteId.toLowerCase().includes(filterKey)
          )
        : siteLocations,
    });
    postUserLog({
      event: "Search Site",
      data: {
        action: "Searched for site " + filterKey,
        module: "Site List",
        section: "Search Site",
        siteUId: "HOME",
        widget: "",
      },
    });
  };

  function populatePopupData(data) {
    togglePopup();
    postUserLog({
      event: "Site Description",
      data: {
        action: data.siteName + " Site Description icon clicked",
        module: "Site List",
        section: "Site Description",
        siteUId: data.siteId,
        widget: "Site Description",
      },
    });
    setPopupData({ siteData: data });
  }

  const renderTitle = () => {
    return (
      <div className="popup_title_container">
        <div>
          <p style={{ fontSize: "large" }}>
            {popupData.siteData.siteName} ({popupData.siteData.siteId})
          </p>
        </div>
        <div
          onClick={togglePopup}
          style={{ cursor: "pointer", fontSize: "large" }}
        >
          <i className="fas fa-times"></i>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    return (
      <ScrollView
        contentContainerStyle={{ flexGrow: 1, height: "550px" }}
        id="scrollview"
        {...scrollConfig}
      >
        <div>
          <center>
            {popupData.siteData.siteImage && (
              <ManageImage data={popupData.siteData.siteImage} />
            )}
            {!popupData.siteData.siteImage && <ManageImage data={null} />}

            <br />
            <h4>{popupData.siteData.siteAddress}</h4>
            <h4>{popupData.siteData.siteDescription}</h4>
            <br />
            <Link
              to={"/sitehome/" + category + "/" + popupData.siteData.siteId}
              onClick={(e) => {
                userMetrics(
                  popupData.siteData.siteName,
                  popupData.siteData.siteId
                );
              }}
            >
              <h5>Launch Site</h5>
            </Link>
          </center>
        </div>
      </ScrollView>
    );
  };

  function setMarkerDataToZoom(id) {
    let data = _.find(locationList, ["siteId", id]);

    setZoomSiteInfo(data);
    setZoomMarker({ lat: data.siteLatitude, lng: data.siteLongitude });
    postUserLog({
      event: "Site Location Zoom",
      data: {
        action: data.siteName + " location zoom icon clicked",
        module: "Site List",
        section: "Site Location Zoom",
        siteUId: id,
        widget: "Site Location Zoom",
      },
    });
  }

  function getMapData() {
    let mapData = [];

    if (siteLocations && siteLocations.length > 0)
      mapData = siteLocations.map((data) => {
        return {
          latLng: { lat: data.siteLatitude, lng: data.siteLongitude },
          title: data.siteName,
          siteId: data.siteId,
          deployStatus: data.deployStatus,
        };
      });

    return mapData;
  }

  useEffect(() => {
    if (activeTier) {
      actions.fetchSiteLocations(dispatch, category + `&tier=${activeTier}`);
    }
    actions.fetchUserHighestTier(dispatch);
  }, []);

  const upIcon = (
    <i className="fa fa-sort-up fa-lg" style={{ marginTop: "10px" }}></i>
  );
  const downIcon = <i className="fa fa-sort-down fa-lg"></i>;
  const userMetrics = (siteName, siteId) => {
    postUserLog({
      event: "Site Selection",
      data: {
        action: "Site location selected to " + siteName,
        module: "Site List",
        section: "Site Selection",
        siteUId: siteId,
        widget: "",
      },
    });
  };

  return (
    <>
      <section className="page-content ">
        {config.DEV_DISPLAY_OPTIONS && <div className="map">
          <SiteMap
            markersData={getMapData()}
            zoomMarker={zoomMarker}
            sbg={category}
            zoomSiteInfo={zoomSiteInfo}
          />
        </div>}

        <div className={showSites ? "site-list" : "site-list-closed"}>
          <div className="site-head">
            <div className="page-heading">
              <h3> {!showSites ? "Choose your Site" : ""} </h3>
            </div>
            <div
              className="show-site-btn"
              onClick={() => setShowSites(!showSites)}
            >
              {showSites ? upIcon : downIcon}
            </div>
          </div>

          {showSites && (
            <>
              <div className="site-head">
                <div className="page-heading">
                  <h2>
                    {category !== "All" && (
                      <span
                        className={
                          "icon icon-" + NEXUS_CONST.SBG_ICON_CLS[category]
                        }
                      ></span>
                    )}{" "}
                    {NEXUS_CONST.SBG_LABEL_TXT[category]}
                  </h2>
                </div>
                {activeTier && (
                  <div className="dx-field" style={{ marginBottom: "0px" }}>
                    <div className="dx-field-value">
                      <span className="tier-container">
                        <SelectBox
                          items={tierList}
                          value={activeTier}
                          handleChange={onTierChange}
                        />
                      </span>
                    </div>
                  </div>
                )}
                <div className="search">
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Search Sites"
                      value={filterVal}
                      onChange={filterSites}
                    />
                    <span className="icon search-icon"></span>
                  </div>
                </div>
              </div>

              {locationList && locationList.length > 0 && (
                <div className="site-body all-sites-lst">
                  <ScrollView id="scrollview" {...scrollConfig}>
                    <div className="site-body" style={{ paddingRight: "10px" }}>
                      {locationList.map((data, siteIndex) => (
                        <div key={siteIndex} className="sites">
                          <span
                            className="site-zoom-map"
                            onClick={(e) => {
                              setMarkerDataToZoom(data.siteId);
                            }}
                          >
                            <i className="fas fa-search-location "></i>
                          </span>
                          <span
                            className="site-image-popup"
                            onClick={(e) => {
                              populatePopupData(data);
                            }}
                          >
                            <i className="fas fa-info-circle"></i>
                          </span>
                          <Link
                            to={"/sitehome/" + category + "/" + data.siteId}
                            onClick={(e) => {
                              userMetrics(data.siteName, data.siteId);
                            }}
                          >
                            <h4>{data.siteName}</h4>
                            <h4>({data.siteId})</h4>
                            <p>{data.siteAddress}</p>{" "}
                          </Link>
                        </div>
                      ))}
                      {locationList && locationList.length === 0 && (
                        <div className="no-site-fnd">
                          <span>No data.</span>
                        </div>
                      )}
                    </div>
                  </ScrollView>

                  <Popup
                    visible={isPopupVisible}
                    hideOnOutsideClick={true}
                    onHiding={togglePopup}
                    titleRender={renderTitle}
                    contentRender={renderContent}
                    height={700}
                    width={1000}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </section>
    </>
  );
};
export default SiteLocation;
